import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "printshop_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (item) => setItems((prev) => [...prev, { ...item, cart_id: crypto.randomUUID() }]);
  const removeItem = (cart_id) => setItems((prev) => prev.filter((i) => i.cart_id !== cart_id));
  const updateItem = (cart_id, patch) =>
    setItems((prev) => prev.map((i) => (i.cart_id === cart_id ? { ...i, ...patch } : i)));
  const clear = () => setItems([]);

  const subtotal = items.reduce((acc, it) => acc + Number(it.line_total || 0), 0);
  const count = items.reduce((acc, it) => acc + Number(it.quantity || 0), 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateItem, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
